import { integrationTypeToIntegrationTypeObject } from "./integrationType";

const integrationResponseToIntegrationObject = (response) => {
    return {
        integrationType: integrationTypeToIntegrationTypeObject(response.integration_type),
        integrationId: response.id,
        integrationName: response.integration_name,
        createdAt: response.created_at,
        integrationTypeId: response.integration_type_id,
        importType: response.import_type,
        active: response.active,
        integrationProcessingStatus: response.integration_processing_status,
        ratingProcessingStatus: response.rating_processing_status,
        trackingProcessingStatus: response.tracking_processing_status,
        adjustmentProcessingStatus: response.adjustment_processing_status,
        autoImport: response.auto_import,
        filePath: response.file_path,
        totalRecords: response.total_records,
        hasErrors: response.has_errors,
        separator: response.separator,
        includesHeader: response.includes_header,
        initialSyncTimeframe: response.initial_sync_timeframe
    };
};

const integrationObjectToIntegrationRequest = (integration) => {
    return {
        integration_name: integration.integrationName,
        integration_type_id: integration.integrationTypeId,
        import_type: integration.importType,
        active: integration.active,
        auto_import: integration.autoImport,
        file_path: integration.filePath,
        params: integration.params,
        separator: integration.separator,
        includes_header: integration.includesHeader,
        initial_sync_timeframe: integration.initialSyncTimeframe
    };
};

export { integrationResponseToIntegrationObject, integrationObjectToIntegrationRequest };
